export default "assets/images/phone-out-d513a938.svg";